<template>
  <div v-if="hasErrors" class="error-block">
    <div class="error-icon">
      <svg
        width="50"
        height="50"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.758 21.258C11.8832 20.1332 13.409 19.5013 15 19.5013C16.591 19.5013 18.1168 20.1332 19.242 21.258M10.5 12H10.515M19.5 12H19.515M28.5 15C28.5 16.7728 28.1508 18.5283 27.4724 20.1662C26.7939 21.8041 25.7995 23.2923 24.5459 24.5459C23.2923 25.7995 21.8041 26.7939 20.1662 27.4724C18.5283 28.1508 16.7728 28.5 15 28.5C13.2272 28.5 11.4717 28.1508 9.83377 27.4724C8.19588 26.7939 6.70765 25.7995 5.45406 24.5459C4.20047 23.2923 3.20606 21.8041 2.52763 20.1662C1.84919 18.5283 1.5 16.7728 1.5 15C1.5 11.4196 2.92232 7.9858 5.45406 5.45406C7.9858 2.92232 11.4196 1.5 15 1.5C18.5804 1.5 22.0142 2.92232 24.5459 5.45406C27.0777 7.9858 28.5 11.4196 28.5 15Z"
          stroke="#000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div class="error-label">Ошибка</div>
      <div class="error-note">
        Нам очень жаль. Попробуйте обновить страницу или заглянуть к нам позже.
        <br />
        Извините за технические проблемы.
      </div>
    </div>

    <div class="accordion">
      <button @click="toggleDetails" class="accordion-button">
        {{ isOpen ? 'Скрыть детали ошибки' : 'Показать детали ошибки' }}
      </button>

      <transition @enter="enter" @leave="leave">
        <div v-show="isOpen" class="accordion-content" ref="accordion">
          <div v-if="errorMessage" class="error-main mt-4">
            {{ errorMessage }}
          </div>
          <ul v-if="errors.length" class="error-list">
            <li
              v-for="(error, index) in errors"
              :key="index"
              class="error-item"
            >
              <span class="error-msg">{{ error.msg }}</span>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
// TODO: можно написать метод отправки отчета, в случае получения ошибки P.S через родителя, здесь мало данных
export default {
  name: 'ErrorBlock',
  props: {
    errorMessage: {
      type: String,
      default: 'Произошла ошибка',
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    hasErrors() {
      return this.errorMessage || this.errors.length;
    },
  },
  methods: {
    toggleDetails() {
      this.isOpen = !this.isOpen;
    },
    enter(el) {
      el.style.height = '0px';
      requestAnimationFrame(() => {
        el.style.transition = 'height 0.3s ease';
        el.style.height = el.scrollHeight + 'px';
      });
    },
    leave(el) {
      el.style.height = el.scrollHeight + 'px';
      requestAnimationFrame(() => {
        el.style.transition = 'height 0.3s ease';
        el.style.height = '0px';
      });
    },
  },
};
</script>

<style scoped>
.error-block {
  background-color: #f9f9f9;
  border: 1px solid #d1d1d1;
  padding: 1.5rem;
  border-radius: 12px;
  color: #000;
  font-family: sans-serif;
}

.error-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
}

.error-label {
  font-weight: bold;
  text-transform: uppercase;
  font-size: 0.9rem;
  margin-top: 0.4rem;
  letter-spacing: 1px;
}

.error-note {
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: #333;
  text-align: center;
}

.accordion-button {
  background: transparent;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  cursor: pointer;
  border-radius: 6px;
  font-size: 0.9rem;
  margin: 0 auto;
  display: block;
  color: #000;
}

.accordion-button:hover {
  background: #eaeaea;
}

.accordion-content {
  overflow: hidden;
  max-height: 200px;
}

.error-main {
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.error-list {
  padding-left: 0;
  margin: 0;
}

.error-item {
  list-style: none;
  margin-bottom: 0.5rem;
  display: flex;
  font-size: 0.95rem;
}

.error-attr {
  font-weight: bold;
  margin-right: 0.3rem;
}

.error-msg {
  color: #444;
}

/* transition */
.accordion-enter-active,
.accordion-leave-active {
  transition: max-height 0.3s ease;
}
.accordion-enter,
.accordion-leave-to {
  max-height: 0;
}
</style>



// WEBPACK FOOTER //
// AppErrorsBlock.vue?12c1e2b4